export default __webpack_public_path__ + "static/media/hollowTrashcan.17ccd49a.svg";